import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=93336784"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=93336784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
